


export { axios, API, Loading, getSession, SUCCESS_REPONSE_CODE, useRouter, REDIRECT, useState, useTranslation,
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode,  toastr, UNAUTHORIZED_REPONSE_CODE,
         useEffect, useSWR, clearSWRCache, TRANSLATION, Yup, ErrorPages, ClientDashboard, Image, motion,
         PAGE_ANIMATION_OPTIONS, Tooltip, Link, SendRequest, BrowserDetect, useUser, CustomToastrAction,CommonAction, useRef} from '@/imports-files/common/common';


export {DashboardService} from '@/services/pages/clients/activities/index';
export {MyAccountService} from '@/services/pages/clients/my-account-service';
export {MyTeamService} from '@/services/pages/clients/my-team-service';
export { MergeRecordsService } from '@/services/pages/clients/jobs/merge-records';
export {ActivitiesAction} from '@/actions/pages/clients/activities/index';
export {CalendarAction} from '@/actions/components/calendar/calendar';
export { CandidateMergeAction } from '@/actions/pages/clients/activities/candidate-merge-action';

// TODO NEED TO BE CHANGE
export {MY_ACCOUNT} from '@/constants/pages/clients/my-account';
export { ACTIVITIES } from '@/constants/pages/clients/activities';

export { default as ThirdPartyLogo} from '@/components/third-party-logo';
export { default as QuickAdd} from '@/components/quick-add';
export { NextSteps } from '@/components/dashboardComponents/next-steps';
export { BrowserNotification } from '@/components/browser-notification';
export { default as InfiniteScroll } from 'react-infinite-scroll-component';
export { SetIcons } from '@/actions/common/setIcons';
export { logoutUser } from '@/actions/common/authentication/logout';
export { default as usePushNotifications} from '@/actions/common/useNotification';
export { closeModalUsingState } from '@/actions/common/close-modal';



export {default as MyIntegrations} from '@/pages/clients/dashboard/my-integration';
export {default as CompanyIntegrations} from '@/pages/clients/dashboard/company-integrations';
export {default as MyPreferences} from '@/pages/clients/dashboard/my-preferences';
export {default as CustomizeCareer} from '@/pages/clients/dashboard/career/customize-career';
export {default as CareerSetting} from '@/pages/clients/dashboard/career/career-setting';
export {default as MyAccount} from '@/pages/clients/dashboard/my-account.js';
export {default as AddTeams} from '@/pages/clients/dashboard/add-team';
export {default as PrivacyPolicy} from '@/pages/clients/dashboard/data-privacy/privacy-policy';

export {SkipModal} from '@/components/skip-modal';
export { default as ProgressLine } from "@/components/progressline";
export { InterviewListDetails } from '@/components/interview-list-details'
export { ConfirmationModal } from '@/components/confirmation-modal';
export { AgencyAcceptRejectModal } from '@/components/agency-accept-reject';
export { OfferRejectedReasons } from '@/components/offer-rejected-reasons';
export { Tab, Tabs, TabList, TabPanel } from "react-tabs";
export { UserSwitch } from '@/components/user-switch';
export { default as CalendarDate }  from '@/components/calendar/calendar-date';
export { default as CalendarWeek } from '@/components/calendar/calendar-week';
export { default as CalendarMonth } from '@/components/calendar/calendar-month';
export { InformationModal } from '@/components/modals/information-modal';


export { default as Warning } from "public/icons/warning.svg";
export { default as ArrowUp } from "public/icons/arrowup.svg";
export { default as ArrowDown } from "public/icons/arrowdown.svg";
export { default as ArrowUp2 } from "public/icons/arrow-up-2.svg";
export { default as ArrowDown2 } from "public/icons/arrow-down-2.svg";
export { default as Phone } from 'public/icons/call.svg';
export { default as Tech } from 'public/icons/technical.svg';
export { default as Video } from 'public/icons/video.svg';
export { default as Face } from 'public/icons/user.svg';
export { default as Communication } from "public/new-icons/message.svg";
export { default as PageStyle } from "@/styles/components/progressline/_index.module.scss";
export { default as Clock} from 'public/icons/clocktime.svg';
export { default as Calendar} from 'public/icons/calender.svg';
export { default as Close} from 'public/icons/close.svg';
